/* =====================================================================
   FALSE CANVAS — theme behaviour.
   Vanilla, no dependencies. Progressive: every control has a no-JS path.
   ===================================================================== */
(function () {
  "use strict";

  /* ---- Header: hairline appears once you leave the top ---- */
  var header = document.querySelector("[data-header]");
  if (header) {
    var onScroll = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 16);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---- Mobile drawer ---- */
  var burger = document.querySelector("[data-burger]");
  var drawer = document.querySelector("[data-drawer]");
  if (burger && drawer) {
    burger.addEventListener("click", function () {
      var open = drawer.classList.toggle("is-open");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  /* ---- Product: variant selection without a page reload ---- */
  document.querySelectorAll("[data-variant-picker]").forEach(function (root) {
    var data = null;
    try {
      data = JSON.parse(root.querySelector("[data-variant-json]").textContent);
    } catch (e) {
      return;
    }

    var idInput = root.querySelector("[data-variant-id]");
    var priceEl = root.querySelector("[data-variant-price]");
    var compareEl = root.querySelector("[data-variant-compare]");
    var stockEl = root.querySelector("[data-variant-stock]");
    var skuEl = root.querySelector("[data-variant-sku]");
    var submit = root.querySelector("[data-add]");
    var buttons = root.querySelectorAll("[data-variant-option]");

    var money = function (cents) {
      var fmt = root.getAttribute("data-money-format") || "${{amount}}";
      var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
    };

    var select = function (id) {
      var v = data.filter(function (x) { return String(x.id) === String(id); })[0];
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price);
          compareEl.classList.remove("hide");
        } else {
          compareEl.classList.add("hide");
        }
      }
      if (skuEl) skuEl.textContent = v.sku || "—";
      if (stockEl) {
        if (!v.available) {
          stockEl.textContent = "SOLD OUT";
          stockEl.classList.add("t-ink");
        } else if (v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 4) {
          stockEl.textContent = "ONLY " + v.inventory_quantity + " LEFT";
          stockEl.classList.add("t-ink");
        } else {
          stockEl.textContent = "IN STOCK";
          stockEl.classList.remove("t-ink");
        }
      }
      if (submit) {
        submit.disabled = !v.available;
        submit.textContent = v.available ? submit.getAttribute("data-label-add") : submit.getAttribute("data-label-out");
      }
      buttons.forEach(function (b) {
        b.setAttribute("aria-current", String(b.getAttribute("data-variant-option") ) === String(v.id) ? "true" : "false");
      });
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", v.id);
        history.replaceState({}, "", url.toString());
      }
    };

    buttons.forEach(function (b) {
      b.addEventListener("click", function () { select(b.getAttribute("data-variant-option")); });
    });

    if (idInput && idInput.value) select(idInput.value);
  });

  /* ---- Product media: thumbnails swap the stage ---- */
  document.querySelectorAll("[data-media-gallery]").forEach(function (root) {
    var stage = root.querySelector("[data-media-stage]");
    if (!stage) return;
    root.querySelectorAll("[data-media-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        stage.src = thumb.getAttribute("data-media-src");
        stage.srcset = thumb.getAttribute("data-media-srcset") || "";
        root.querySelectorAll("[data-media-thumb]").forEach(function (t) {
          t.setAttribute("aria-current", t === thumb ? "true" : "false");
        });
      });
    });
  });

  /* ---- Cart count badge kept in sync after AJAX adds ---- */
  var refreshCount = function () {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + "cart.js" : "/cart.js", {
      headers: { "Accept": "application/json" }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.querySelectorAll("[data-cart-dot]").forEach(function (el) {
          el.classList.toggle("hide", cart.item_count === 0);
        });
      })
      .catch(function () {});
  };

  /* ---- Add to cart: stay on the page, confirm in the chrome ---- */
  document.querySelectorAll("form.fc-cart-form").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      if (!window.fetch) return; /* no-JS / old browser: normal POST */
      e.preventDefault();
      var submit = form.querySelector("[data-add]");
      var label = submit ? submit.textContent : "";
      if (submit) { submit.disabled = true; submit.textContent = "WRITING…"; }
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/") + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded", "Accept": "application/json" },
        body: new URLSearchParams(new FormData(form)).toString()
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (submit) {
            submit.disabled = false;
            submit.textContent = res && res.status ? "UNAVAILABLE" : "ADDED TO CART";
            setTimeout(function () { submit.textContent = label; }, 1800);
          }
          refreshCount();
        })
        .catch(function () {
          if (submit) { submit.disabled = false; submit.textContent = label; }
        });
    });
  });

  /* ---- Cart page: quantity steppers post the form ---- */
  document.querySelectorAll("[data-qty]").forEach(function (root) {
    var input = root.querySelector("input");
    root.querySelectorAll("[data-qty-step]").forEach(function (b) {
      b.addEventListener("click", function () {
        var next = parseInt(input.value, 10) + parseInt(b.getAttribute("data-qty-step"), 10);
        input.value = Math.max(0, next);
        input.form.submit();
      });
    });
  });
})();
